export default __webpack_public_path__ + "static/media/rocket.5198d59f.svg";